// extracted by mini-css-extract-plugin
module.exports = {"container":"e__w","widget":"e_0w","title":"e_1w","msrp":"e_2w","separator":"e_3w","textBadge":"e_4w"};